import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconCriticalSvg } from "./IconCriticalSvg.mjs";
const IconCritical = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconCriticalSvg, ...svgProps }) });
export {
  IconCritical
};
